const iconKeys = {
  看板管理: "icon-shuju",
  录音管理: "icon-luyin",
  数据总览: "icon-shujuxian",
  明细查询: "icon-zhanghumingxi",
  竞品分析: "icon-duibi",
  系统设置: "icon-shezhi",
  注销登录: "icon-zhuxiaodenglu",
  用户: "icon-yonghu",
  配置: "icon-peizhi",
  消息: "icon-xiaoxi1"
};

export default iconKeys;
